import { canv } from "@/canv/global";

export class ZoomToVis {
    constructor(transformation: ZoomToVisTransformation, steps = 25) {
        this.transformation = transformation;
        this.remainingSteps = steps;
    }

    draw() {}

    step() {
        if (canv.m[4] > 0) {
            if (this.transformation["4"] > 0) {
                canv.m[4] += (this.transformation["4"] - canv.m[4]) / this.remainingSteps;
            } else {
                const delta = Math.abs(this.transformation["4"] - canv.m[4]);

                canv.m[4] -= delta / this.remainingSteps;
            }
        } else {
            if (this.transformation["4"] > 0) {
                const delta = Math.abs(this.transformation["4"] - canv.m[4]);

                canv.m[4] += delta / this.remainingSteps;
            } else {
                canv.m[4] += (this.transformation["4"] - canv.m[4]) / this.remainingSteps;
            }
        }

        if (canv.m[5] > 0) {
            if (this.transformation["5"] > 0) {
                canv.m[5] += (this.transformation["5"] - canv.m[5]) / this.remainingSteps;
            } else {
                const delta = Math.abs(this.transformation["5"] - canv.m[5]);

                canv.m[5] -= delta / this.remainingSteps;
            }
        } else {
            if (this.transformation["5"] > 0) {
                const delta = Math.abs(this.transformation["5"] - canv.m[5]);

                canv.m[5] += delta / this.remainingSteps;
            } else {
                canv.m[5] += (this.transformation["5"] - canv.m[5]) / this.remainingSteps;
            }
        }

        const mn = (this.transformation["0"] - canv.m[0]) / this.remainingSteps;

        canv.m[0] += mn;
        canv.m[3] += mn;

        canv.ctx.setTransform(canv.m[0], 0, 0, canv.m[3], canv.m[4], canv.m[5]);
        canv.updateZoomDisplay();

        this.remainingSteps--;

        if (this.remainingSteps <= 0) {
            this.finished = true;
        }
    }

    name = "zoomTo";
    finished = false;
    transformation: ZoomToVisTransformation;
    remainingSteps = 25;
}

export type ZoomToVisTransformation = {
    0: number;
    3: number;
    4: number;
    5: number;
};
